module.exports = __webpack_public_path__ + "assets/2c80b1d37c287aa0f94f67e0988e0712.mp3";